import Callout from "./Callout";

export default Callout;
